import React, { createContext, useContext, useState } from "react";
import { IMenuContext } from "../exports/interfaces";

const MenuContext = createContext<IMenuContext>({
  menuOpen: true,
  setMenuOpen: () => null,
  handleStateChange: () => null,
});
export const useMenu = () => useContext(MenuContext);

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleStateChange = (state: { isOpen: boolean }) => {
    setMenuOpen(state.isOpen);
  };

  return (
    <MenuContext.Provider value={{ menuOpen, setMenuOpen, handleStateChange }}>
      {children}
    </MenuContext.Provider>
  );
};
